const USE_SUBSCRIPTIONS = false;

const urlParams = new URLSearchParams(window.location.search);
const productHandle = urlParams.get('product_handle');

const mainProductHandle = window.planWizardData.mainProductHandle;
const queryString = window.planWizardData.queryString;
const planObject = window.planWizardData.planObject;
const tokensf = "4fecfda6ea46f6b0aadcc3d478c2aa6d";
const storeUrl = "stem-cord";

let productDataOriginal;
let productData;

async function getPlanVariantFromMainVariant(variantId) {
  if (!USE_SUBSCRIPTIONS) return null;
  const query = `
    query getVariantPlanProduct($id: ID!) {
      node(id: $id) {
        ... on ProductVariant {
          metafield(namespace: "custom", key: "variants_plan_product") {
            reference {
              ... on ProductVariant {
                id
                title
                sellingPlanAllocations(first: 5) {
                  nodes {
                    sellingPlan {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

  const res = await fetch("https://"+storeUrl+".myshopify.com/api/2023-10/graphql.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": tokensf,
    },
    body: JSON.stringify({ query, variables: { id: `gid://shopify/ProductVariant/${variantId}` } }),
  });

  const json = await res.json();
  const planVariant = json.data?.node?.metafield?.reference;

  if (!planVariant) {
    console.error("❌ Main variant does not have a plan variant assigned!");
    return null;
  }

  return planVariant;
}

async function fetchProduct(handle) {
    // console.log('THE HANDLE', handle);
  const res = await fetch(`/products/${handle}.js`);
  return res.json();
}

async function init() {
  if (!productHandle) {
    console.error('No product handle found');
    return;
  }

  //  Fetch original product
  const originalQuery = `
    query getOriginal($handle: String!) {
      productByHandle(handle: $handle) {
        title
        metafield(namespace: "custom", key: "plan_product") {
          reference {
            ... on Product { handle }
          }
        }
        sellingPlanDescriptions: metafield(namespace: "custom", key: "selling_plan_descriptions") { value }
        monthlyStorage: metafield(namespace: "custom", key: "monthly_storage") { value }
      }
    }
  `;

  const originalRes = await fetch("https://"+storeUrl+".myshopify.com/api/2023-10/graphql.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": tokensf
    },
    body: JSON.stringify({ query: originalQuery, variables: { handle: productHandle } })
  });

  const originalData = await originalRes.json();
  const originalProduct = originalData?.data?.productByHandle;
  if (!originalProduct) {
    console.error('Original product not found!');
    return;
  }

  //  Parse original product metafields
  let planDescriptions = {};
  let monthlyStorage = {};
  try {
    planDescriptions = originalProduct.sellingPlanDescriptions?.value
      ? JSON.parse(originalProduct.sellingPlanDescriptions.value)
      : {};
  } catch (e) {
    console.error('Invalid JSON in selling_plan_descriptions:', e);
  }

  try {
    monthlyStorage = originalProduct.monthlyStorage?.value
      ? JSON.parse(originalProduct.monthlyStorage.value)
      : {};
  } catch (e) {
    console.error('Invalid JSON in monthly_storage:', e);
  }

  //  Get plan product handle (if it exists)

  /*Isidro 12/22*/
  //const planProductHandle = originalProduct.metafield?.reference?.handle;
  //const handleToUse = planProductHandle || productHandle;
  let handleToUse = productHandle;

  if (USE_SUBSCRIPTIONS) {
    const planProductHandle = originalProduct.metafield?.reference?.handle;
    if (planProductHandle) {
      handleToUse = planProductHandle;
    }
  }
   /*Isidro 12/22*/
  
  // console.log("Plan product handle:", handleToUse);

  //  Fetch selling plans for chosen product
  const planQuery = `
    query getPlanProduct($handle: String!) {
      productByHandle(handle: $handle) {
        title
        handle
        sellingPlanGroups(first: 10) {
          edges {
            node {
              name
              sellingPlans(first: 10) {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
          }
        }
        sellingPlanDescriptions: metafield(namespace: "custom", key: "selling_plan_descriptions") {
          value
        }
        monthlyStorage: metafield(namespace: "custom", key: "monthly_storage") {
          value
        }
      }
    }
  `;

  const planRes = await fetch("https://"+storeUrl+".myshopify.com/api/2023-10/graphql.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": tokensf
    },
    body: JSON.stringify({ query: planQuery, variables: { handle: handleToUse } })
  });

  const planData = await planRes.json();
  const planProduct = planData?.data?.productByHandle;

  // console.log('planProduct', planProduct);
  // console.log('planData', planData);
  
  if (!planProduct) {
    console.error('Plan product not found!');
    return;
  }

  productData = await fetchProduct(handleToUse);

  productDataOriginal = await fetchProduct(productHandle);

  //  Update product title in DOM
  document.querySelectorAll('.plan-title').forEach(el => {
    el.innerText += ` ${originalProduct.title}`;
  });

  //  Build wizard items
  const wizardItemsContainer = document.querySelector('.wizard-items');
  wizardItemsContainer.innerHTML = '';  

  async function getConversionData() {
    let userCurrency = "USD"; // fallback
    let userLang = navigator.language || "en"; // fallback
    let rate = 1; // default fallback

    // 1. Get user location / currency
    try {
      const geo = await fetch("https://ipwhois.app/json/").then(r => r.json());
      if (geo && geo.success) {
        //  Use the currency_code for FX & formatting
        if (geo.currency_code) userCurrency = geo.currency_code;

        // Use browser language; ipwhois doesn't return language
        userLang = navigator.language || "en";
      }
    } catch (e) {
      console.warn("Geo lookup failed, using defaults USD/en");
    }

    // 2. Get FX rates safely
    try {
      const ratesData = await fetch("https://api.exchangerate-api.com/v4/latest/USD")
        .then(r => r.json());

      if (ratesData && ratesData.rates && ratesData.rates[userCurrency]) {
        rate = ratesData.rates[userCurrency];
      } else {
        console.warn("Currency not found in FX API, using fallback rate=1");
      }
    } catch (e) {
      console.warn("Rates API failed, using fallback rate=1");
    }

    return { userCurrency, userLang, rate };
  }

  const { userCurrency, userLang, rate } = await getConversionData();

  async function applyApproxToAddons() {
    const { userCurrency, userLang, rate } = await getConversionData();

    document.querySelectorAll(".addon-checkbox").forEach(input => {
      // Extract USD from Shopify price (already preformatted)
      const usd = parseFloat(input.dataset.price.replace(/[^0-9.]/g, "")) || 0;

      const converted = usd * rate;

      const formattedConverted = new Intl.NumberFormat(userLang, {
        style: "currency",
        currency: userCurrency,
        minimumFractionDigits: 0
      }).format(converted);

      // 💾 Store conversion info INSIDE THE INPUT
      input.dataset.priceUsd = usd.toFixed(2);
      input.dataset.priceConverted = converted.toFixed(2);
      input.dataset.currency = userCurrency;
      input.dataset.priceConvertedFormatted = formattedConverted;

      // Also update the UI button's approx text (optional)
      const wrapper = input.closest("[data-addon-wrapper]");
      const btnAdd = wrapper?.querySelector(".btn-add");
      const approxSpan = wrapper?.querySelector(".approx-price");
      

      if (approxSpan && USE_SUBSCRIPTIONS) {
        approxSpan.textContent = ` (Aprox. ${formattedConverted} ${userCurrency}) `;
      }
    });
  }

  applyApproxToAddons();


  
  if (productDataOriginal.variants && productDataOriginal.variants.length > 0) {
    productDataOriginal.variants.forEach(variant => {
      const variantDiv = document.createElement('div');
      const variantId = variant.id;
      const variantTitle = variant.title || 'Default Variant';

      // Original price in USD cents
      const priceInCents = parseInt(variant.price, 10) || 0;
      const usdPrice = priceInCents / 100;

      // Format original USD price
      const formattedUSD = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0
      }).format(usdPrice);

      // Convert USD → user's currency
      const converted = usdPrice * rate;

      // Format converted price
      const formattedConverted = new Intl.NumberFormat(userLang, {
        style: "currency",
        currency: userCurrency,
        minimumFractionDigits: 0
      }).format(converted);      

      variantDiv.innerHTML = `
        <input class="product-checkbox visibility-hidden"
              type="radio"
              data-title="${variantTitle}"
              data-price="${formattedUSD}"
              data-price-aprox="${formattedConverted}"
              data-currency="${userCurrency}"
              id="variant-${variantId}"
              name="variant"              
              value="${variantId}"
              required>
    
        <label for="variant-${variantId}" class="wizard-item w-100">
          <div class="d-flex product-title">
            <div class="button"></div>
            <div class="w-100">
              <div class="d-flex justify-content-between">
                <div class="desc">
                  <h3 class="body-text">${variantTitle}</h3>
                </div>                
              </div>
              <div>
                <ul>                    
                  <li class="d-flex justify-content-between align-items-between">
                    <div>Procesamiento</div>
                    <div class="text-end">${formattedUSD} COP</div>
                                        
                  </li>                    
                </ul>
              </div>
            </div>
          </div>
        </label>
      `;
      //<div class="text-end">${formattedUSD} USD<br>(Aprox. ${formattedConverted} ${userCurrency})</div>


      wizardItemsContainer.appendChild(variantDiv);
    });
  } else {
    wizardItemsContainer.innerHTML = '<p>No variants available.</p>';
  }



  // 7️⃣ Initialize events
  initializeWizardEvents();
}


  
init(); // <-- this is crucial


async function addItem(variantId, properties = {}) {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      properties: properties
    })
  });

  if (!response.ok) {
    const errorData = await response.json();
    console.error('Error adding item:', errorData);
    throw new Error('Failed to add item to cart');
  }

  return response.json();
}

async function addProduct(variantId, addonsSummary = {}) {
  const payload = {
    id: variantId,
    quantity: 1,    
  };

  if (Object.keys(addonsSummary).length > 0) {
    payload.properties = { ...addonsSummary };
  }
  
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    const errorData = await response.json();
    console.error('Error adding item:', errorData);
    throw new Error('Failed to add item to cart');
  }

  return response.json();
}

async function addPlan(planId, variantId, properties = {}) {
  if (!USE_SUBSCRIPTIONS) return null;

  const payload = {
    id: variantId,
    quantity: 1,
    selling_plan: planId,
    properties: properties
  };

  // Only include properties if there are any  

  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    const errorData = await response.json();
    console.error('Error adding item:', errorData);
    throw new Error('Failed to add item to cart');
  }

  return response.json();
}

async function getVariantPlanProductHandle(variantId) {
  if (!USE_SUBSCRIPTIONS) return null;
  const query = `
    query getVariantPlanProduct($id: ID!) {
      node(id: $id) {
        ... on ProductVariant {
          metafield(namespace: "custom", key: "variants_plan_product") {
            reference {
              ... on ProductVariant { id, product { handle } }
            }
          }
        }
      }
    }
  `;

  const res = await fetch("https://"+storeUrl+".myshopify.com/api/2023-10/graphql.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": tokensf
    },
    body: JSON.stringify({ query, variables: { id: `gid://shopify/ProductVariant/${variantId}` } })
  });

  const data = await res.json();

  // Extract the product handle
  const handle = data?.data?.node?.metafield?.reference?.product?.handle;
  return handle || null;
}




function initializeWizardEvents() {
     //FIRST STEP
     $('input[name="kit"]').on('change', function () {
       var kitValue = $(this).val();

       //window.location.href = "./wizard_2.html";
     });

     $('#form').on('submit', async (e) => {
        e.preventDefault();

      const selectedPlan = form.querySelector('input[name="variant"]:checked');
      const selectedAddOns = Array.from(form.querySelectorAll('input[name="addon"]:checked'));

      if (!selectedPlan || !selectedAddOns.length){
        console.error('Variant does not have a plan product handle!');
          $(".wizard-toast").addClass("show");
          $(".wizard-toast").text("Please select an add on to continue");
        setTimeout(() => {            
          $(".wizard-toast").removeClass("show");
                    
        }, 4000);

        return;
      } 

      try {
        const selectedVariantId = selectedPlan.value;

        // Collect add-ons
        const addonsSummary = {};
        selectedAddOns.forEach(addon => {
          const title = addon.dataset.title || 'Add-on';
          const price = addon.dataset.price || '';
          if (title && price) addonsSummary[title] = price;
        });

        // Fetch the plan product handle from the variant metafield
        // console.log('selectedVariantId',selectedVariantId)

        //const variantPlanProductHandle = await getVariantPlanProductHandle(selectedVariantId);    

        // console.log("variantPlanProductHandle", variantPlanProductHandle, typeof variantPlanProductHandle);
        

        /*if (!variantPlanProductHandle) {
          console.error('Variant does not have a plan product handle!');
           $(".wizard-toast").addClass("show");
           $(".wizard-toast").text("Variant does not have a plan product handle");
          setTimeout(() => {            
            $(".wizard-toast").removeClass("show");
            window.location.href = '/pages/cotiza';
            
          }, 4000);
          

          return;
        }*/
        let variantPlanProductHandle = null;
        if (USE_SUBSCRIPTIONS) {
          variantPlanProductHandle = await getVariantPlanProductHandle(selectedVariantId);
        }

        // Find the correct plan variant via metafield mapping        
        /*
        const planVariant = await getPlanVariantFromMainVariant(selectedVariantId);

        if (!planVariant) return;

        const sellingPlanId = planVariant.sellingPlanAllocations?.nodes?.[0]?.sellingPlan?.id;

        if (!sellingPlanId) {
          console.error("No selling plan found for this variant!");
          $(".wizard-toast").addClass("show");
          $(".wizard-toast").text("No selling plan found for this variant");
          setTimeout(() => {            
            $(".wizard-toast").removeClass("show");
            window.location.href = '/pages/cotiza';
            //const url = new URL(window.location.href);
            //url.search = "";
            //history.replaceState(null, "", url.toString());
          }, 4000);
          return;
        }


        // console.log('sellingPlanId', sellingPlanId);
        // console.log('planVariant.id', planVariant.id);

        const numericVariantId = planVariant.id.replace('gid://shopify/ProductVariant/', '');
        const numericSellingPlanId = sellingPlanId.replace('gid://shopify/SellingPlan/', '');


        // console.log('numericVariantId', numericVariantId);

        // Add plan + product
        await addPlan(numericSellingPlanId, numericVariantId, { kit_id: selectedVariantId });*/

        let sellingPlanId, numericVariantId, numericSellingPlanId;

        if (USE_SUBSCRIPTIONS) {
            const planVariant = await getPlanVariantFromMainVariant(selectedVariantId);

            if (!planVariant) {
                showToast("No plan variant found!");
                return;
            }

            sellingPlanId = planVariant.sellingPlanAllocations?.nodes?.[0]?.sellingPlan?.id;

            if (!sellingPlanId) {
                showToast("No selling plan found for this variant!");
                return;
            }

            numericVariantId = planVariant.id.replace('gid://shopify/ProductVariant/', '');
            numericSellingPlanId = sellingPlanId.replace('gid://shopify/SellingPlan/', '');

            await addPlan(numericSellingPlanId, numericVariantId, { kit_id: selectedVariantId });
        }

        await addProduct(selectedVariantId, addonsSummary);

        // Add add-ons
        for (const addon of selectedAddOns) {
          await addItem(addon.value, { kit_id: selectedVariantId });
        }

        window.location.href = '/cart';

      } catch (error) {
        console.error(error);
        alert('There was an error adding to cart. Please try again!');
      }
    });


     $('input[name="variant"]').on('change', function () {       
        var title = $(this).data('title'); 
        var price = $(this).data('price'); 
        var priceAprox = $(this).data('price-aprox'); 
        var priceCurrency = $(this).data('currency'); 

        $('#planName').text(title);
        if(USE_SUBSCRIPTIONS)
        {
          $('#planPrice').html(`${price} USD<br>(Aprox. ${priceAprox} ${priceCurrency})`);
        }
        else
        {
          $('#planPrice').html(`${price} COP`);  
        }

         $('#step-2 .cryo-buttons.primary').removeClass('disabled');
     });

     $('input[name="addon"]').on('change', function () {      
      const selectedAddons = $('input[name="addon"]:checked');
      let summaryHtml = '';

      selectedAddons.each(function () {
        const title = $(this).data('title');
        const price = $(this).data('price');
        const convPrice = $(this).data('price-converted-formatted');
        const locCurrency = $(this).data('currency');

        summaryHtml += `
          <div class="desc d-flex justify-content-between">
            <p class="h3">${title}</p>
            <p class="h3 text-end">${price} COP</span></p>
            <!--p class="h3 text-end">${price} USD <br> <span>(Aprox. ${convPrice} ${locCurrency})</span></p-->
          </div>
        `;
      });

      // Update the summary area
      $('#addonSummary').html(summaryHtml);

      if (selectedAddons.length > 0) {
        $('#addonWrapper').show();        
      } else {
        $('#addonWrapper').hide();    
      }

      $('#step-3 .cryo-buttons.primary').removeClass('disabled');
     });         

      //Tooltipster
     $('input, select').tooltipster({
         trigger: 'custom',
         onlyOne: false,
         position: 'right',
         theme: 'tooltipster-light'
     });

      //Validation
     $("#form").validate({
         errorPlacement: function (error, element) {
         var lastError = $(element).data('lastError'),
             newError = $(error).text();

         $(element).data('lastError', newError);

         if (newError !== '' && newError !== lastError) {
             $(element).tooltipster('content', newError);
             $(element).tooltipster('show');
         }
         },
         success: function (label, element) {
             $(element).tooltipster('hide');
         }
     });

     var navListItems = $('div.wizard-progress div a.wizard-btn'),
         allWells = $('.setup-content'), 
         allNextBtn = $('.cryo-buttons.primary');


     allWells.hide();
     $('#step-2').show();

      //Wizard nav click
     navListItems.click(function (e) {
         var href = $(this).attr('href');

          //Only prevent default if it's an in-page step (e.g., "#step-2")
         if (href.startsWith("#")) {
             e.preventDefault();
             var $target = $(href),
                 $item = $(this);

             if (!$item.hasClass('disabled')) {
                 navListItems.removeClass('active').addClass('inactive');
                 $item.addClass('active');

                 $('input, select').each(function () {
                     if ($(this).data('tooltipster-ns')) {
                         $(this).tooltipster('hide');
                     }
                 });

                 allWells.hide();
                 $target.show();
                 $target.find('input:eq(0)').focus();
             }
         }
     });


      // Next button click
     allNextBtn.click(function () {
         var curStep = $(this).closest(".setup-content"),
         curStepId = curStep.attr("id"),
         nextStepWizard = $('div.wizard-progress div a[href="#' + curStepId + '"]').parent().next().find('a'),
         curInputs = curStep.find("input, select, textarea"),
         isValid = true;

         for (var i = 0; i < curInputs.length; i++) {
         if (!$(curInputs[i]).valid()) {
             isValid = false;
         }
         }

         if (isValid) {
         nextStepWizard.removeClass('disabled');
         nextStepWizard.trigger('click');
         }
     });

     $('div.wizard-progress div a[href="#step-2"]').trigger('click');

    $('#go-to-cart').on('click', async (e) => {
      e.preventDefault();
    
      const form = document.getElementById('form');
      const selectedPlan = form.querySelector('input[name="variant"]:checked');
    
      if (!selectedPlan) {
        // console.log('Please select a plan before submitting.');
        return;
      }
    
      try {
        const selectedVariantId = selectedPlan.value;                

        // Fetch the plan product handle from the variant metafield
        // console.log('selectedVariantId',selectedVariantId)

        //const variantPlanProductHandle = await getVariantPlanProductHandle(selectedVariantId);    

        // console.log("variantPlanProductHandle", variantPlanProductHandle, typeof variantPlanProductHandle);
        

        /*if (!variantPlanProductHandle) {
          console.error('Variant does not have a plan product handle!');
          $(".wizard-toast").addClass("show");
          $(".wizard-toast").text("Variant does not have a plan product handle");
          setTimeout(() => {            
            $(".wizard-toast").removeClass("show");
            window.location.href = '/pages/cotiza';
            //const url = new URL(window.location.href);
            //url.search = "";
            //history.replaceState(null, "", url.toString());
          }, 4000);          

          return;
        }*/
        let variantPlanProductHandle = null;
        if (USE_SUBSCRIPTIONS) {
          variantPlanProductHandle = await getVariantPlanProductHandle(selectedVariantId);
        }

        // Find the correct plan variant via metafield mapping                
        /*const planVariant = await getPlanVariantFromMainVariant(selectedVariantId);

        if (!planVariant) return;

        const sellingPlanId = planVariant.sellingPlanAllocations?.nodes?.[0]?.sellingPlan?.id;

        if (!sellingPlanId) {
          console.error("No selling plan found for this variant!");
          $(".wizard-toast").addClass("show");
          $(".wizard-toast").text("No selling plan found for this variant");
          setTimeout(() => {            
            $(".wizard-toast").removeClass("show");
            window.location.href = '/pages/cotiza';
            //const url = new URL(window.location.href);
            //url.search = "";
            //history.replaceState(null, "", url.toString());
          }, 4000);

          return;
        }


        // console.log('sellingPlanId', sellingPlanId);
        // console.log('planVariant.id', planVariant.id);

        const numericVariantId = planVariant.id.replace('gid://shopify/ProductVariant/', '');
        const numericSellingPlanId = sellingPlanId.replace('gid://shopify/SellingPlan/', '');


        // console.log('numericVariantId', numericVariantId);

        // Add plan + product
        await addPlan(numericSellingPlanId, numericVariantId, { kit_id: selectedVariantId });*/

        let sellingPlanId, numericVariantId, numericSellingPlanId;
        if (USE_SUBSCRIPTIONS) {
            const planVariant = await getPlanVariantFromMainVariant(selectedVariantId);

            if (!planVariant) {
                showToast("No plan variant found!");
                return;
            }

            sellingPlanId = planVariant.sellingPlanAllocations?.nodes?.[0]?.sellingPlan?.id;

            if (!sellingPlanId) {
                showToast("No selling plan found for this variant!");
                return;
            }

            numericVariantId = planVariant.id.replace('gid://shopify/ProductVariant/', '');
            numericSellingPlanId = sellingPlanId.replace('gid://shopify/SellingPlan/', '');

            await addPlan(numericSellingPlanId, numericVariantId, { kit_id: selectedVariantId });
        }

        await addProduct(selectedVariantId);

        // const firstVariantId = productData.variants[0].id;
    
        // await addPlan(selectedPlan.value, firstVariantId);
        

        // console.log('Plan added to cart (no addons).');
        window.location.href = '/cart';
      } catch (error) {
        console.error(error);
        alert('There was an error adding to cart. Please try again!');
      }
    });


    var allPrevBtn = $(".all-prev-btn");

    allPrevBtn.click(function () {
        var curStep = $(this).closest(".setup-content"),
            curStepId = curStep.attr("id"),
            prevStepWizard = $('div.wizard-progress div a[href="#' + curStepId + '"]').parent().prev().find('a');
  
        prevStepWizard.removeClass('disabled');
        prevStepWizard.trigger('click');
    });
  
    $('div.wizard-progress div a[href="#step-2"]').trigger('click');
    
    
 };

/*
 const form = document.getElementById('form');
 form.addEventListener('submit', async (e) => {
  e.preventDefault();
});*/


  // Get all addon wrappers
  document.querySelectorAll('[data-addon-wrapper]').forEach(wrapper => {
    const checkbox = wrapper.querySelector('.addon-checkbox');
    const btnAdd = wrapper.querySelector('.btn-add').parentElement;
    const btnRemove = wrapper.querySelector('.btn-remove');

    // Add Add-on
    btnAdd.addEventListener('click', () => {      
      checkbox.checked = true;
      checkbox.dispatchEvent(new Event('change')); // Trigger the change event
      btnAdd.style.display = 'none';
      btnRemove.style.display = 'inline-block';
    });

    // Remove Add-on
    btnRemove.addEventListener('click', () => {
      checkbox.checked = false;
      checkbox.dispatchEvent(new Event('change')); // Trigger the change event
      btnRemove.style.display = 'none';
      btnAdd.style.display = 'inline-flex';
    });
  });

function showToast(message) {
  $(".wizard-toast").addClass("show").text(message);
  setTimeout(() => $(".wizard-toast").removeClass("show"), 4000);
}